export interface AkhdariSection {
  title: string;
  paragraphs: { en: string; ar: string }[];
}

export const akhdariContent: AkhdariSection[] = [
  {
    title: "Opening",
    paragraphs: [
      {
        en: "In the Name of Allah the Merciful, the Compassionate. Praise be to Allah the Lord of Creation. Prayers and peace be upon our Master Muhammad, the Seal of the Prophets and the Imam of the Messengers.",
        ar: "بسم الله الرحمن الرحيم. الحمد لله رب العالمين والصلاة والسلام على سيدنا محمد خاتم النبيين وإمام المرسلين"
      },
      {
        en: "The first obligation upon the responsible one is to correct his faith. Then [he must] know what is necessary to correct his farḍ ʿayn, such as the rules of prayer, purification and fasting.",
        ar: "أول ما يجب على المكلف تصحيح إيمانه ثم معرفة ما يصلح به فرض عينه كأحكام الصلاة والطهارة والصيام"
      },
      {
        en: "The responsible one is obligated to preserve the boundaries of Allāh and observe His commands and prohibitions. The responsible one must repent before Allāh becomes angry with him.",
        ar: "ويجب عليه أن يحافظ على حدود الله ويقف عند أمره ونهيه ويتوب إلى الله سبحانه قبل أن يسخط عليه"
      }
    ]
  },
  {
    title: "Conditions of Repentance (Tawbah)",
    paragraphs: [
      {
        en: "The conditions of repentance (tawbah) are: 1. Remorse over what was done, 2. An intention never to return to the sin for the rest of his life, and 3. To leave the sin immediately if he was in the midst of performing it.",
        ar: "وشروط التوبة الندم على ما فات والنية أن لا يعود إلى ذنب فيما بقي من عمره وأن يترك المعصية في ساعتها إن كان متلبسا بها"
      },
      {
        en: "It is not permissible to delay repentance nor to say, \"I will repent once Allāh guides me.\" Verily this is from amongst the signs of wretchedness, abandonment, and blinding of the spiritual inner sight.",
        ar: "ولا يحل له أن يؤخر التوبة ولا يقول حتى يهديني الله فإنه من علامات الشقاء والخذلان وطمس البصيرة"
      }
    ]
  },
  {
    title: "Guarding the Tongue",
    paragraphs: [
      {
        en: "It is an obligation for the responsible one to protect his tongue from: 1. Foul speech, 2. Evil speech, 3. Ugly words, 4. Swearing by divorce, 5. Ridiculing a Muslim, 6. Mocking a Muslim, 7. Cursing a Muslim, 8. Frightening a Muslim without a valid reason.",
        ar: "ويجب عليه حفظ لسانه من الفحشاء والمنكر والكلمة القبيحة وأيمان الطلاق وانتقاص المسلم وإهانته وسبه وتخويفه في غير حق شرعي"
      }
    ]
  },
  {
    title: "Guarding the Eyes",
    paragraphs: [
      {
        en: "It is an obligation upon the responsible one to protect his eyes from looking at the prohibited. It is not permissible for him to look at a Muslim in a way that harms him unless the person is a transgressor (fāsiq) in which case one must not keep his company.",
        ar: "ويجب عليه حفظ بصره من النظر إلى الحرام ولا يحل له أن ينظر إلى مسلم بنظرة تؤذيه إلا أن يكون فاسقا فيجب عليه"
      }
    ]
  },
  {
    title: "Guarding the Limbs",
    paragraphs: [
      {
        en: "It is an obligation upon the responsible one to protect his limbs to the best of his ability. He must love, hate, be pleased and be angry for the sake of Allāh. He must enjoin righteousness and forbid evil.",
        ar: "ويجب عليه حفظ جميعه وجواب حده ما استطاع وأن يحب لله ويبغض لله ويرضى لله ويغضب لله ويأمر بالمعروف وينهى عن المنكر"
      },
      {
        en: "He is prohibited from: 1. Lying, 2. Backbiting, 3. Carrying tales, 4. Arrogance, 5. Vanity, 6. Showing off, 7. Bragging, 8. Jealousy, 9. Hate, 10. Seeing oneself as better than others, 11. Mockery, 12. Fornication, 13. Looking at a non-mahram woman, 14. Consuming wealth of people without consent, 15. Delaying the prayer beyond its times.",
        ar: "ويحرم عليه الكذب والغيبة والنميمة والكبر والعجب والرياء والسمعة والحسد والبغض ورؤية الفضل على الغير والهمز واللمز والعبث والسخرية والزنا والنظر إلى الأجنبية وأكل أموال الناس بغير طيب نفس وتأخير الصلاة عن أوقاتها"
      }
    ]
  },
  {
    title: "Obedience to the Creator",
    paragraphs: [
      {
        en: "It is not permissible to befriend a transgressor (fāsiq) nor to sit with him unless there is a necessity. The responsible one should not seek the acceptance of the creation by angering the Creator.",
        ar: "ولا يحل له صحبة فاسق ولا مجالسته لغير ضرورة ولا يطلب رضا المخلوق بسخط الله سبحانه"
      },
      {
        en: "The Messenger of Allāh ﷺ said, \"There is no obedience to a creature in that which is disobedience to the Creator.\" It is not permissible to do anything until he knows what Allāh has ordained in that matter.",
        ar: "وقال عليه الصلاة والسلام: لا طاعة لمخلوق في معصية الخالق. ولا يحل له أن يفعل فعلة حتى يعلم حكم الله فيه"
      }
    ]
  },
  {
    title: "Section of Purification (Ṭahāra)",
    paragraphs: [
      {
        en: "Purification is two types: 1. Purification from ḥadath, 2. Purification from filth (khabath). Purification is not achieved except with pure water that has not changed in color, taste or smell by something not normally part of it.",
        ar: "فصل في الطهارة: الطهارة حدث وطهارة خبث ولا يصح الجمع إلا بالماء الذي لم يتغير لونه أو طعمه أو رائحه بكماله يفابقه"
      },
      {
        en: "Such as: oil, fat, grease, grime, soap, filth, and the like. There is no harm with: dirt, mud, salt, plaster, and the like.",
        ar: "كالزيت والسمن والودك والوسخ والصابون والنجاسة ونحوه. ولا بأس بالتراب والحمأة والسبخة ونحوه"
      }
    ]
  },
  {
    title: "Impurity (Najāsa)",
    paragraphs: [
      {
        en: "If the spot where an impurity affects is known, that place is washed. If the place is not known, the entire garment is washed. If one is in doubt, he must sprinkle water on that area.",
        ar: "فصل: إذا تعينت النجاسة غسل محلها وإن لم يعلم غسل الثوب كله ومن شك في إصابة شيء نضح"
      },
      {
        en: "If one remembers an impurity during prayer, he must stop unless he fears losing the time. If one prays with impurity out of forgetfulness, he repeats the prayer if the time is still in.",
        ar: "ومن تذكر النجاسة في الصلاة قطع إلا أن يخاف خروج الوقت ومن صلى بنجاسة وتذكر بعد السلام أعاد في الوقت"
      }
    ]
  },
  {
    title: "Obligations of Wuḍū' (Ablution)",
    paragraphs: [
      {
        en: "The obligations of wuḍū' are seven: 1. An intention, 2. Washing the face, 3. Washing the arms up to and including the elbows, 4. Wiping the head, 5. Washing the feet up to and including the ankles, 6. Rubbing, 7. Continuity.",
        ar: "فصل: فرائض الوضوء سبع: النية وغسل الوجه وغسل اليدين إلى المرفقين ومسح الرأس وغسل الرجلين إلى الكعبين والدلك والفور"
      }
    ]
  },
  {
    title: "Sunnas of Wuḍū'",
    paragraphs: [
      {
        en: "The sunnas of wuḍū' are: 1. Washing the hands to the wrists, 2. Rinsing the mouth, 3. Sniffing water into the nose, 4. Blowing water out, 5. A return wipe of the head, 6. Wiping the ears, 7. Renewing water for the ears, 8. Keeping obligations in order.",
        ar: "وسننه: غسل اليدين إلى الكوعين عند الشروع والمضمضة والاستنشاق والاستنثار وبده مسح الرأس والأذنين وتجديد الماء لما بين الفرائض والترتيب"
      }
    ]
  },
  {
    title: "Recommended Acts of Wuḍū'",
    paragraphs: [
      {
        en: "The recommended acts are: 1. Bismillāh, 2. Brushing teeth, 3. Second and third washing, 4. Beginning with front of head, 5. Order between sunnas, 6. Little water, 7. Right before left. Rubbing between fingers is obligatory; between toes is recommended.",
        ar: "وفضائله: التسمية والسواك والثائلة على الغسل والوجه واليدين والبداءة بمقدم الرأس وترتيب السنة وقلة الماء وتقديم اليمنى على اليسرى ويجب تخليل أصابع اليدين ويستحب في أصابع الرجلين"
      }
    ]
  },
  {
    title: "Nullifiers of Wuḍū'",
    paragraphs: [
      {
        en: "The nullifiers are: Direct nullifiers (aḥdāth): urination, defecation, passing wind, madhy, wady. Causes (asbāb): heavy sleep, unconsciousness, intoxication, insanity, kissing, touching a woman with pleasure, touching the penis with the palm.",
        ar: "فصل: نواقض الوضوء أحداث وأسباب. فالأحداث: البول والغائط والريح والمذي والودي. والأسباب: النوم الثقل والإغماء والسكر والجنون ولمس المرأة إن قصد اللذة أو وجدها ومس الذكر بباطن الكف أو بباطن الأصابع"
      }
    ]
  },
  {
    title: "Prohibitions Without Wuḍū'",
    paragraphs: [
      {
        en: "It is not permissible without wuḍū' to: pray, perform ṭawāf, touch a copy of the Qur'ān or its cover (exception: what one is studying from). Whoever intentionally prays without wuḍū' is a disbeliever — we seek refuge in Allāh.",
        ar: "فصل: لا يحل لغير المتوضئ الصلاة ولا الطواف ولا مس نسخة القرآن العظم ولا بيده ولا بعود ونحوه إلا الجزء منه المتعلم فيه. ومن صلى بغير وضوء عامدا فهو كافر والعياذ بالله"
      }
    ]
  },
  {
    title: "Obligations of Ghusl",
    paragraphs: [
      {
        en: "Ghusl is required for: 1. Janāba, 2. Ḥayḍ, 3. Nifās. Janāba is: exiting of semen with pleasure, or entrance of the glans into the vagina. Obligations of ghusl: intention, continuity, rubbing, covering the body with water.",
        ar: "فصل: يجب الغسل من ثلاثة أشياء: الجنابة والحيض والنفاس. فالجنابة قسمان: خروج المني بلذة معتادة ومغيب الحشفة في الفرج. وفرائض الغسل: النية عند الشروع والفور والدلك والموالاة"
      }
    ]
  },
  {
    title: "Tayammum (Dry Ablution)",
    paragraphs: [
      {
        en: "A traveler may perform tayammum if not disobedient. The sick may do so for farḍ or nāfila. The healthy resident may if he fears losing the prayer time. Two farḍ prayers cannot be prayed with one tayammum.",
        ar: "فصل في التيمم: ويتيمم المسافر في غير معصية أو نافلة ويتيمم الحاضر الصحيح للفرائض إذا خاف خروج وقتها ولا تصلى فريضتان بتيمم واحد"
      },
      {
        en: "Its obligations are: 1. Intention, 2. Pure earth, 3. Wiping the face, 4. Wiping hands to wrists, 5. First strike, 6. Continuity, 7. Time being in, 8. Connected to the prayer. Pure earth includes: dirt, rock, snow, mud.",
        ar: "وفرائض التيمم: النية والصعيد الطاهر ومسح الوجه ومسح اليدين إلى الكوعين والضربة الأولى والفور ودخول الوقت واتصاله بالصلاة. والصعيد هو التراب والحجر والثلج والخشب ونحو ذلك"
      }
    ]
  },
  {
    title: "Ḥayḍ (Menstruation)",
    paragraphs: [
      {
        en: "Women are: first-time, regular, or pregnant. Max first cycle is 15 days. It is not permissible for a menstruating woman to: pray, fast, perform ṭawāf, touch the Qur'ān, or enter a masjid. She makes up fasts but not prayers.",
        ar: "فصل في الحيض: والنساء مبتدأة ومعتادة وحامل وأكثر الحيض للمبتدأة خمسة عشر يوما. ولا يحل للحائض الصلاة ولا الصوم ولا الطواف ولا مس مصحف ولا دخول مسجد وعليها قضاء الصوم دون الصلاة"
      }
    ]
  },
  {
    title: "Nifās (Post Partum Discharge)",
    paragraphs: [
      {
        en: "Nifās is like ḥayḍ in what is prevented. Maximum is 60 days. If blood stops before that, even on the day of birth, she performs ghusl and prays.",
        ar: "فصل في النفاس: والنفاس كالحيض في منعه وأكثره ستون يوما فإذا انقطع الدم قبلها ولو في يوم الولادة اغتسلت وصلت"
      }
    ]
  },
  {
    title: "Prayer Times",
    paragraphs: [
      {
        en: "Ẓuhr: from post-zenith until shadow equals object. ʿAsr: from end of ẓuhr until yellowing. Ḍarūrī of both: until sunset. Maghrib: from sunset for the time needed to pray. ʿIshā': from disappearance of redness until first third of night. Ṣubḥ: from fajr until isfār.",
        ar: "فصل في الأوقات: المختار للظهر من زوال الشمس إلى آخر القامة. والمختار للعصر من القامة إلى الاصفرار وضروريهما إلى الغروب. والمختار للمغرب قبل ما تصل فيه بعد شروطها. والمختار للعشاء من مغيب الشفق إلى ثلث الليل. والمختار للصبح من الفجر إلى الاسفار"
      }
    ]
  },
  {
    title: "Conditions of the Prayer",
    paragraphs: [
      {
        en: "Conditions: 1. Purity from ḥadath, 2. Purity from filth on body/clothes/place, 3. Covering the ʿawra, 4. Facing qibla, 5. Leaving speech, 6. Leaving excessive actions. Man's ʿawra: navel to knees. Woman: entire body except face and hands.",
        ar: "فصل في شروط الصلاة: الطهارة من الحدث والطهارة من الخبث من الثوب والمكان وستر العورة واستقبال القبلة وترك الكلام وترك الأفعال الكثيرة. وعورة الرجل ما بين السرة إلى الركبة والمرأة كلها عورة ما عدا الوجه والكفين"
      }
    ]
  },
  {
    title: "Obligations of the Prayer",
    paragraphs: [
      {
        en: "The 14 obligations: 1. Intention, 2. Takbīr al-iḥrām, 3. Standing for it, 4. Fātiḥa, 5. Standing for it, 6. Rukūʿ, 7. Rising from it, 8. Sujūd on forehead, 9. Rising from it, 10. Standing upright, 11. Stillness, 12. Order, 13. Final salām, 14. Sitting for salām.",
        ar: "فرائض الصلاة: نية الصلاة المعينة وتكبيرة الإحرام والقيام لها والفاتحة والقيام لها والركوع والرفع منه والسجود على الجبهة والرفع منه والاعتدال والطمأنينة والترتيب بين فرائضها والسلام والجلوس الذي يقابله"
      }
    ]
  },
  {
    title: "Sunnas & Recommended Acts of Prayer",
    paragraphs: [
      {
        en: "Sunnas include: iqāma, sūra after fātiḥa, standing for it, silent/audible recitation, samiʿa Allāhu liman ḥamidah, every takbīr except the first, both tashah-huds, sitting for them, sūra order, salām for follower, ṣalāh upon the Prophet ﷺ, sujūd on nose/hands/knees/feet, sutra.",
        ar: "وسننها: الإقامة وسورة بعد الفاتحة والقيام لها والسر فيما يسر والجهر فيما يجهر وسمع الله لمن حمده وكل تكبيرة سوى الأولى والتشهدان والجلوس لهما وتقديم الفاتحة والسلام والصلاة على رسول الله والسجود على الأنف والكفين والركبتين وأطراف القدمين والسترة"
      }
    ]
  },
  {
    title: "The Light & Spirit of Prayer",
    paragraphs: [
      {
        en: "Prayer has an immense light that causes hearts to radiate. None attain it except those with khushūʿ. Empty your heart of the dunyā. Believe that prayer is submissiveness through standing, bowing, and prostration, and glorification through takbīr and tasbīḥ.",
        ar: "فصل: للصلاة نور عظيم تشرق به قلوب المصلين ولا يناله إلا الخاشعون فإذا أتيت إلى الصلاة ففرغ قلبك من الدنيا وما فيها واعتقد أن الصلاة خشوع وتواضع لله سبحانه بالقيام والركوع والسجود وإجلال وتعظيم له بالتكبير والتسبيح"
      }
    ]
  },
  {
    title: "Graded Forms of Prayer",
    paragraphs: [
      {
        en: "The prayer has 7 ordered forms. Obligatory order for 4: standing without leaning, standing with leaning, sitting without leaning, sitting with leaning. Recommended order for 3: right side, left side, on one's back.",
        ar: "فصل: للصلاة المفروضة سبع أحوال مرتبة: القائم بغير استناد ثم القائم باستناد ثم الجلوس بغير استناد ثم الجلوس باستناد. والمستحبة: على جنبه الأيمن ثم الأيسر ثم على ظهره"
      }
    ]
  },
  {
    title: "Make-up Prayers (Qaḍā')",
    paragraphs: [
      {
        en: "It is obligatory to make up owed prayers. Whoever prays five make-ups daily is not careless. Make-up is permissible at any time. One who owes qaḍā' should not pray nāfila except: shafīʿ, witr, fajr, two ʿĪds, eclipse, and rain prayers.",
        ar: "فصل: يجب قضاء ما في الذمة من الصلوات ولا يحل التفريط فيها ومن صلى كل يوم خمسا فليس بمفرط. ويجوز القضاء في كل وقت ولا يتنفل إلا الشفع والوتر والفجر والعيدان والخسوف والاستسقاء"
      }
    ]
  },
  {
    title: "Chapter on Sahw (Forgetfulness)",
    paragraphs: [
      {
        en: "Sujūd al-sahw is sunna. For subtraction: two prostrations before salām (qablī). For addition: two after salām (baʿdī). For both: before salām. The qablī is for missing two or more sunnas. One sunna requires no prostration unless it was silent/audible recitation.",
        ar: "باب في السهو: وسجود السهو في الصلاة سنة فللنقصان سجدتان قبل السلام وللزيادة بعد السلام. ومن نقص وزاد سجد قبل السلام. ومن نقص سنتين فأكثر سجد قبل السلام وأما السنة الواحدة فلا سجود لها إلا السر والجهر"
      },
      {
        en: "Whoever speaks out of forgetfulness prostrates after salām. Whoever laughs invalidates his prayer. The muwaswis (one with constant doubt) must ignore the doubt and prostrate after salām whether he doubted addition or subtraction.",
        ar: "ومن تكلم بعد السلام ساهيا سجد بعد السلام. ومن ضحك في الصلاة بطلت صلاته. والموسوس يتركه الوسواس ولكنه يسجد بعد السلام سواء شك في زيادة أو نقصان"
      }
    ]
  }
];
